import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed bottom-0 z-50 w-full bg-white xl:hidden" }
const _hoisted_2 = { class: "border-t-2" }
const _hoisted_3 = { class: "flex justify-evenly w-full text-2xl text-center text-primary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "inline-block relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shopping-cart" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "grid absolute bottom-4 left-4 place-content-center w-4 h-4 text-xs text-white bg-red-500 rounded-full"
}

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  emits: ["toggle-cart", "toggle-route"],
  setup(__props, { emit }) {

const store = useStore();
const shoppingCartList = computed(() => store.state.shoppingCartList);


const toggleCart = () => emit("toggle-cart");
const toggleRoute = (path: string) => emit("toggle-route", path);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "flex-1 pt-6 pb-8 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleRoute('/')))
        }, _hoisted_5),
        _createElementVNode("div", {
          class: "flex-1 pt-6 pb-8 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleRoute('/browse')))
        }, _hoisted_7),
        _createElementVNode("div", {
          class: "flex-1 pt-6 pb-8 cursor-pointer",
          onClick: toggleCart
        }, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_unref(shoppingCartList).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(shoppingCartList).length), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})